import React from 'react';
import RamadanSubscription from './RamadanSubscription';
import SubscriptionSummary from './SubscriptionSummary';
import SubscriptionPayment from './SubscriptionPayment';
import SubscriptionConfirmation from './SubscriptionConfirmation';
import AddressList from '../../../feature/checkout/AddressList';
import Location from '../../../feature/location/Location';

export const subscriptionPrefix = 'subscription';

const subscriptionRoutes = [
  {
    path: `/ramadan-subscription`, // Ramadan Landing Page
    component: RamadanSubscription,
    key: 'ramadanSubscription',
    exact: true,
    isPrivate: false,
  },
  {
    path: `/subscription-summary/:subscriptionId`, // Ramadan Summary Page
    component: SubscriptionSummary,
    key: 'subscriptionSummary',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${subscriptionPrefix}/payment`, // Final payment page.
    component: SubscriptionPayment,
    key: 'payment',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${subscriptionPrefix}/successful/:subscriptionNo`, // Payment success page.
    component: SubscriptionConfirmation,
    key: 'subscriptionConfirmation',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${subscriptionPrefix}/available-address`, // Address List
    component: AddressList,
    key: 'addressList',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${subscriptionPrefix}/new-address/:addressId?`, // New address form with map.
    component: React.lazy(() =>
      import('./../../../feature/checkout/AddAddress')
    ),
    key: 'addAddress',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${subscriptionPrefix}/location`, // Search for location
    component: Location,
    key: 'location',
    exact: true,
    isPrivate: true,
  },
];

export const getSubscriptionRoute = key => {
  if (key) {
    const route = subscriptionRoutes.find(route => route.key === key);
    if (route) return route.path;
  }
  return `/${subscriptionPrefix}/`;
};

export default subscriptionRoutes;
